export default __webpack_public_path__ + "434a59dd5865e680ee61d79dde9e17ff.png";